import React from "react";
import { Phone } from "../../types";
import { Text } from "@jarvis-catalyst/ui-components";

type Props = {
  phones?: Phone[];
};

const PhonesTab = ({ phones }: Props): JSX.Element => {
  return (
    <>
      {phones?.map((phone, index) => (
        <div key={index}>
          <div className="row">
            <div className="col">
              <Text className="">Phone Number</Text>
              <input type="text" className="form-control" disabled value={phone.phoneNumber} />
            </div>
            <div className="col"></div>
          </div>

          <div className="row">
            <div className="col">
              <Text className="">Verified Phone Number</Text>
              <input
                type="text"
                className="form-control"
                disabled
                value={String(phone.verifiedPhoneNumber)}
              />
            </div>

            <div className="col">
              <Text className="">Preferred Phone Number</Text>
              <input
                type="text"
                className="form-control"
                disabled
                value={String(phone.preferredPhoneNumber)}
              />
            </div>
          </div>
          <hr />
        </div>
      ))}
    </>
  );
};

export default PhonesTab;
